import Icon from '../components/Icon.vue'

Icon.register({
  'chalkboard-teacher': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M208 352c62.1 0 112.3 50.5 112 112.6-0.1 26.3-21.7 47.4-48 47.4h-224c-26.3 0-47.9-21.1-48-47.4-0.3-62.1 49.9-112.6 112-112.6 2.4 0 4.8 0.3 7 1.1 13 4.2 26.6 6.9 41 6.9s28-2.7 40.9-6.9c2.3-0.7 4.7-1.1 7.1-1.1zM160 320c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zM592 0c26.5 0 48 22.3 48 49.6v316.8c0 27.3-21.5 49.6-48 49.6h-244.6c-6.6-25.3-20.6-47.3-39.7-64h76.2v-64h128v64h64v-288h-352v49.8c-18.9-11-40.6-17.8-64-17.8v-46.4c0-27.3 21.5-49.6 48-49.6h384z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chalkboard-teacher.js
// module id = 1168
// module chunks = 0